import { useEffect, useState } from "react";
import { FaSave } from "react-icons/fa";
// import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { LuX } from "react-icons/lu";
import apiClient from "../../../api-services/ApiClient";
import Preloader from "../../../app-components/preloader/Preloader";
import {
  notifyError,
  notifySuccess,
} from "../../../app-components/toast/toast";

const ManageFunctionalEmail = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [functionalEmail, setFunctionalEmail] = useState<any[]>([]);
  const [list, setList] = useState<string>("");

  useEffect(() => {
    getAll();
  }, []);

  const getAll = async () => {
    setLoading(true);
    try {
      const res: any = await apiClient.get("FunctionalEmail");
      setFunctionalEmail(res.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const createNew = async (e: any) => {
    e.preventDefault();

    const data = { email: list };

    try {
      setLoading(true);
      await apiClient.post(`FunctionalEmail`, data);
      notifySuccess("successful!");
      setList("");
      //! optimistic update later;
      getAll();
    } catch (error: any) {
      notifyError(JSON.stringify(error));
    } finally {
      setLoading(false);
    }
  };

  const updateById = async (id: string) => {
    console.log(id);
    try {
      setLoading(true);
      const data = { email: functionalEmail.find((item) => item.id === id).email };

      await apiClient.put(`FunctionalEmail/${id}`, data);
      notifySuccess("Successful!");
    } catch (error: any) {
      notifyError(JSON.stringify(error));
    } finally {
      setLoading(false);
    }
  };

  // const EnableById = async (id: string) => {
  //   try {
  //     setLoading(true);

  //     let action = true;

  //     if (equipment.find((item) => item.id === id).isDeleted) {
  //       action = false;
  //     }

  //     const data = { isDisabled: action };

  //     await apiClient.patch(`FunctionalEmail/${id}/EnableDisable`, data);

  //     getAllDefect();
  //     notifySuccess("Successful!");
  //   } catch (error: any) {
  //     notifyError(JSON.stringify(error));
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleInputChange = (id: string, value: string) => {
    const list = functionalEmail.map((item: any) =>
      item.id === id ? { ...item, email: value } : item
    );
    setFunctionalEmail(list);
  };

  return (
    <>
      {/* page lead */}
      <section className="flex justify-between items-center bg-gradient-to-r from-secondaryBlue to-primaryBlue shadow-md border-b border-gray-200">
        <div className="xl:container xl:mx-auto md:px-4 py-4 pb-24 flex justify-between items-center">
          <h4 className="lg:text-[16px] text-white nunito font-medium">
            Manage Functional Email
          </h4>
        </div>
      </section>

      {/* page content */}
      <section className="pt-5 mx-auto md:px-4 xl:container relative top-[-100px] xl:top-[-90px]">
        {/* main form questions */}
        <div className="rounded-lg bg-white border border-gray-200 mb-5">
          <div className="p-4">
            <div className="overflow-x-auto">
              <table className="table-auto w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-200 text-left text-xs">
                    <th className="border border-gray-300 px-2 py-2 font-medium text-slate-800 text-center">
                      SN
                    </th>
                    <th className="border border-gray-300 px-2 py-2 font-medium text-slate-800">
                      Name
                    </th>
                    <th className="border border-gray-300 px-2 py-2 font-medium text-slate-800">
                      Action
                    </th>
                    {/* <th className="border border-gray-300 px-2 py-2 font-medium text-slate-800"></th> */}
                    {/* <th className="border border-gray-300 px-2 py-2 font-medium text-slate-800"></th> */}
                  </tr>
                </thead>

                <tbody>
                  {functionalEmail.map((row, index) => (
                    <tr key={index} className="even:bg-gray-50 text-xs">
                      <td className="border border-gray-300 px-2 py-1 text-center">
                        {index + 1}
                      </td>

                      <td className="border border-gray-300 px-2 py-1">
                        {
                          <textarea
                            className="w-full border border-1 p-2"
                            value={row.email}
                            onChange={(e) =>
                              handleInputChange(row.id, e.target.value)
                            }
                            placeholder="Enter Email"
                          ></textarea>
                        }
                      </td>

                      {/* <td className="border border-gray-300 px-2 py-1 w-[100px]">
                        <button
                          onClick={() => {
                            deleteDefectById(row?.id);
                          }}
                          className="text-red-600 flex gap-2 font-medium"
                        >
                          <FaTrash /> Delete
                        </button>
                      </td> */}

                      <td className="border border-gray-300 px-2 py-1 w-[100px]">
                        <button
                          onClick={() => {
                            updateById(row?.id);
                          }}
                          className="text-green-600 flex gap-2 font-medium"
                        >
                          <FaSave /> Update
                        </button>
                      </td>

                      {/* <td className="border border-gray-300 px-2 py-1 w-[100px]">
                        <button
                          onClick={() => {
                            EnableDefectById(row?.id);
                          }}
                          className="text-blue-600 flex gap-2 font-medium"
                        >
                          {row.isDeleted ? <FaEyeSlash /> : <FaEye />}
                          {row.isDeleted ? "Disable" : "Enable"}
                        </button>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="flex gap-3">
              <button
                className="mt-4 text-[10px] flex gap-2 items-center px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-600"
                onClick={() => setModalOpen(true)}
              >
                <span>Add New</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* add new questions */}
      {modalOpen && (
        <section className="fixed inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center">
          <button
            onClick={() => setModalOpen(false)}
            className="mt-4 text-red-600 hover:underline p-3 rounded-full bg-white mb-4 text-xl border border-gray-500 shadow animate-modalShow"
          >
            <LuX />
          </button>

          <div className="bg-white p-12 rounded shadow-md w-full max-w-xl animate-modalShow">
            <form onSubmit={createNew} autoComplete="off">
              <h2 className="text-md font-medium mb-4 flex-col border-b">
                Add new email
              </h2>

              <div className=" max-h-[55vh] overflow-y-scroll">
                <div className="overflow-x-auto">
                  <table className="table-auto w-full border-collapse border border-gray-300">
                    <tbody>
                      <tr className="even:bg-gray-50 text-xs">
                        <td className="border border-gray-300 px-2 py-1">
                          {
                            <textarea
                              className="w-full border border-1 p-2"
                              value={list ?? ""}
                              onChange={(e) => setList(e.target.value)}
                              placeholder="Enter email"
                            ></textarea>
                          }
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <button
                type="submit"
                className="w-full mx-auto flex font-normal justify-center mt-12 text-sm bg-red-700 text-white py-2 rounded hover:bg-red-600"
              >
                Create Email
              </button>
            </form>
          </div>
        </section>
      )}

      <Preloader loading={loading} />
    </>
  );
};

export default ManageFunctionalEmail;
